import Link from "next/link";

export function WhatsNewLink() {
  return <Link href="/changelog">Changelog</Link>;
}
